import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SiteCtx = createContext(null);

export function SiteProvider({ children }) {
  const [launched, setLaunched] = useState(null);
  useEffect(() => {
    api.get("/site").then(({ data }) => setLaunched(data.launched)).catch(() => setLaunched(false));
  }, []);
  return <SiteCtx.Provider value={{ launched, setLaunched }}>{children}</SiteCtx.Provider>;
}

export const useSite = () => useContext(SiteCtx);
